// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Types__Common = require("../Types__Common.bs.js");

function getOptionLabel(x) {
  return x.label;
}

function getOptionValue(x) {
  return Types__Common.PropertyType.toString(x.value);
}

function make(value) {
  return {
          value: value,
          label: Types__Common.PropertyType.toDisplayString(value)
        };
}

var defaultValues = [
  "SINGLE_FAMILY",
  "MULTI_UNIT",
  "CONDO",
  "LOT"
];

var defaultOptions = defaultValues.map(make);

exports.getOptionLabel = getOptionLabel;
exports.getOptionValue = getOptionValue;
exports.make = make;
exports.defaultValues = defaultValues;
exports.defaultOptions = defaultOptions;
/* defaultOptions Not a pure module */
